module.exports = __webpack_public_path__ + "img/specials.98dded00.svg";